<div class="main-container">
    <p class="heading">{{heading}}</p>
    <div class="spacing-container">
        <div class="content-container">
            <div class="row">
                <div class="col-md-6">
                    <app-password-input
                        [label]='"ACCOUNT.CURRENT_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '
                        [inputControl]="password_form.controls['oldPassword']" [inputStyle]="inputStyle"
                        [placeholder]='"ACCOUNT.CURRENT_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '>
                    </app-password-input>
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation1="required" [control]="password_form.controls['oldPassword']"
                        [errorMessage2]='"ACCOUNT.ERROR.PASSWORD_ERROR_PATTERN" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation2="pattern"></app-error-log>
                </div>
            </div>
            <div class="row row-spacing">
                <div class="col-md-6">
                    <app-password-input
                        [label]='"ACCOUNT.NEW_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '
                        [inputControl]="password_form.controls['newPassword']" [inputStyle]="inputStyle"
                        [placeholder]='"ACCOUNT.NEW_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '>
                    </app-password-input>
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation1="required" [control]="password_form.controls['newPassword']"
                        [errorMessage2]='"ACCOUNT.ERROR.PASSWORD_ERROR_PATTERN" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation2="pattern"></app-error-log>
                </div>
                <div class="col-md-6">
                    <app-password-input
                        [label]='"ACCOUNT.CONFIRM_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '
                        [inputControl]="password_form.controls['confirmPassword']" [inputStyle]="inputStyle"
                        [placeholder]='"ACCOUNT.CONFIRM_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async '>
                    </app-password-input>
                    <app-error-log
                        [errorMessage1]='"ACCOUNT.ERROR.GENERIC" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation1="required"
                        [errorMessage2]='"ACCOUNT.ERROR.CONFIRM_PASSWORD" | translateIt: {language: sharedService.currentLanguage} |async'
                        validation2="passwordMismatch"
                        [control]="password_form.controls['confirmPassword']"></app-error-log>
                </div>
            </div>
        </div>
        <div class="btn-container">
            <button class="discard" (click)="togglePassword.emit()">
                <a>
                    {{"ACCOUNT.BUTTON.DISCARD" | translateIt: {language: sharedService.currentLanguage} |async}}
                </a>
            </button>
            <button class="update" (click)="updatePassword($event)" [disabled]="helperService.isLoading">
                <!-- <a> -->
                    @if(!helperService.isLoading){
                        {{"ACCOUNT.BUTTON.UPDATE" | translateIt: {language: sharedService.currentLanguage} |async}}
                    }
                @else{
                <div class="spinner-border" role="status"></div>
                }
                <!-- </a> -->
            </button>
        </div>
    </div>
</div>